import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.js';

const linkClass = ({ isActive }: { isActive: boolean }) =>
  `inline-flex min-h-11 items-center rounded-none px-3 font-display text-xs uppercase tracking-brand ${
    isActive ? 'bg-crimson text-white' : 'text-crimson hover:underline'
  }`;

export function AdminNav() {
  const auth = useAuth();
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <nav aria-label="Administrator" className="flex flex-wrap gap-2">
        <NavLink to="/admin" end className={linkClass}>
          Dashboard
        </NavLink>
        <NavLink to="/admin/requests" className={linkClass}>
          Requests
        </NavLink>
        <NavLink to="/admin/requests/new" className={linkClass}>
          Create request
        </NavLink>
        <NavLink to="/admin/invoices" className={linkClass}>
          Invoices
        </NavLink>
        <NavLink to="/admin/stories" className={linkClass}>
          Stories
        </NavLink>
      </nav>
      <button className="btn-secondary self-start" type="button" onClick={auth.logout}>
        Sign out
      </button>
    </div>
  );
}
